import {
  DIGITAL_ASSETS_REQUEST,
  HEADER_LINKS_REQUEST,
  ECXLUSIVE_UPDATES_REQUEST,
  PRODUCT_INFO_REQUEST,
  PRODUCT_INFO_UPDATE_REQUEST,
  ALL_DETAILS_REQUEST,
  GET_NPS_FEEDBACK_REQUEST,
  GET_NPS_RATING_REQUEST,
  GET_DASHBOARD_STATS_REQUEST,
  PRODUCT_SIGNUP_REQUEST,
  SET_DIGITAL_IMAGE_PREVIEW,
  GET_SE_URL_REQUEST,
  UPDATE_SE_URL_REQUEST
} from './constants';

export function getAllDetails() {
  return { type: ALL_DETAILS_REQUEST };
}

export function getDigitalAssets() {
  return { type: DIGITAL_ASSETS_REQUEST };
}

export function getHeaderbarLinks() {
  return { type: HEADER_LINKS_REQUEST };
}

export function getExclusiveUpdatesLinks() {
  return { type: ECXLUSIVE_UPDATES_REQUEST };
}

export function getProductInformation() {
  return { type: PRODUCT_INFO_REQUEST };
}

export function updateProductInformation(payload) {
  return { type: PRODUCT_INFO_UPDATE_REQUEST, payload };
}

export function getNpsFeedbacks(payload) {
  return { type: GET_NPS_FEEDBACK_REQUEST, payload };
}

export function getNpsRatings() {
  return { type: GET_NPS_RATING_REQUEST };
}

export function getDashboardStats() {
  return { type: GET_DASHBOARD_STATS_REQUEST };
}

export function productSignup(payload) {
  return { type: PRODUCT_SIGNUP_REQUEST, payload };
}

export function getSEUrl(payload) {
  return { type: GET_SE_URL_REQUEST, payload };
}

export function updateSEUrl(payload) {
  return { type: UPDATE_SE_URL_REQUEST, payload };
}

export function setDigitalAssetsImgPreview(payload) {
  return { type: SET_DIGITAL_IMAGE_PREVIEW, payload };
}
